const ACCESSKEY_URLS = { 
    GET_ALL: "/access_key/get_all",
    UPDATE: "/access_key/update",
    INSERT: "/access_key/insert",
    GET_ONE: "/access_key/get_one",
    DELETE: "/access_key/delete_one",
    REGENERATE:"/access_key/regenerate",
    REVOKE:"/access_key/revoke"
  }; 
  
  export {
    ACCESSKEY_URLS
};
